import { action } from 'mobx';
import { API } from 'aws-amplify';
import { FurtherConsiderations } from '../models';

export class FurtherConsiderationsStore {
  @action loadFurtherConsiderations(): Promise<FurtherConsiderations> {
    console.log('*************** loading further considerations ************************');
    return API.get('restAPI', '/furtherConsiderations', {}).then(considerations => {
      console.log(considerations);
      return FurtherConsiderations.createFromConsiderations(considerations);
    }).catch((error) => {
      console.error(error);
      return error;
    });
  }
}